import React,{useState, useEffect}from 'react';
import { useLocation } from 'react-router-dom';
import Blank from './blanks.jsx'
import TermProcurement from './TermProcurement.jsx';
import RVWSDashboard from './RVWSDashboard.jsx';
import ProjectDashboard from './ProjectDashboard.jsx';
import SubmitDocumentsRequestiframe from './SubmitDocumentsRequestiframe.jsx'; 
function Plans() {
  const location = useLocation();
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const projectName = selectedProjectDetail.projectName;
  const [currentComponent, setCurrentComponent] = useState(<ProjectDashboard/>);
  const [activeComponent, setActiveComponent] = useState("projDash");

  useEffect(()=>{
      const getSearch = location.search;
      if(getSearch.includes('projDash')){
        setActiveComponent("projDash")
        setCurrentComponent(<ProjectDashboard/>)
      } else if(getSearch.includes('term')){
        setActiveComponent("term")
        setCurrentComponent(<TermProcurement/>)
      } else if(getSearch.includes('rvws')){
        setActiveComponent("rvws")
        setCurrentComponent(<RVWSDashboard />)
      }
  
    },[location])

  const handleComponentChange = (component) => {
    setCurrentComponent(component);
  };
  return (
    <div className="wbshor">
      <div className="login-header-wrap">
        <div className="login-header">
          <div className="pagetitle">{projectName ? projectName : 'Project Name'}</div>
          <div className="button-wrapper">
            {/* <button className="btntopright" id="optionsBtn">
              <p>&lt;</p>
            </button> */}
            <div className="options-popup" id="optionsPopup">
              <button className="option-btn yellow">Filter <i>▼</i></button>
              <button className="option-btn">Export report <i>▼</i></button>
              <button className="option-btn">Hide Columns <i>▼</i></button>
            </div>
          </div>
          
        </div>

        <div className="container">
          <div className="innerwrap">
            <div className="leftbar">
            
			<button className={`option-btn btn1 ${activeComponent === "projDash" ? 'active' : ''}`} onClick={() => { setActiveComponent("projDash"); handleComponentChange(<ProjectDashboard/>)}}><span><strong>Project Dashboard</strong></span></button>
			{/* <button className={`option-btn btn1 ${activeComponent === "term" ? 'active' : ''}`} onClick={() => { setActiveComponent("term"); handleComponentChange(<TermProcurement/>)}}><span><strong>Term Procurement</strong></span></button> */}
			<button className={`option-btn btn1 ${activeComponent === "rvws" ? 'active' : ''}`} onClick={() => { setActiveComponent("rvws"); handleComponentChange(<RVWSDashboard/>)}}><span><strong>RVWS Dashboard</strong></span></button>
			
			
			
            </div>
           
            {currentComponent}
           
                        
          </div>
        </div>
      </div>
      
    </div>
  );
}

export default Plans;
